import { createApp } from 'vue'

// 引入自动更新提醒
import autoUpdate from './auto-update'
// 非生产环境使用
process.env.VUE_APP_ENV !== 'production' && autoUpdate.start()

// 新素材通知轮询（全局生效：每分钟静默请求未读数，有新增时右上角弹通知）
import '@/utils/notifyPoll'
 

import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import 'element-plus/lib/theme-chalk/index.css'

const app = createApp(App)
// 全局注册element-plus所有图标，模板中可直接引用如<folder-opened />、<MoreFilled />
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store)
app.use(router)
app.use(ElementPlus, { locale })
app.mount('#app')



//   import { ref, reactive, toRefs, watch } from 'vue'
// import router from '@/router/index.js'
// import { onBeforeRouteUpdate } from 'vue-router'F
// 封装组件
// 子组件
// attrs展开接收过来 不需要处理的数据
// <input type="text" v-bind="$attrs" />
// 在子组件接受参数
// props:['items','']
// 在子组件抛出方法
// emits:['update:modelValue']
// ref ref.value.name 可以让对象双向绑定
// reactive 能存放数组 并双向绑定
// toRefs 可以解构...toRefs(user)

// window.addEventListener('load', () => {
//   // 强制刷新页面
//   if (window.location.protocol !== 'https:' && window.location.host !== 'localhost') {
//     window.location.reload(true);
//   }
// });